import { render, staticRenderFns } from "./checkDataView.vue?vue&type=template&id=5cd4e994&"
import script from "./checkDataView.vue?vue&type=script&lang=js&"
export * from "./checkDataView.vue?vue&type=script&lang=js&"
import style0 from "./checkDataView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports